//* 绘图库
import Konva from "konva";
//* 组件属性
import type { GeneticInformationOrigin } from "../../index";

//* 配置类型
interface Setting {
    spacing: number;
    chromosome: number;
    attachments: number;
}

export const render = (origin: GeneticInformationOrigin, stage: Konva.Stage, setting: Setting) => {
    //* 初始化舞台
    const canvas = new Konva.Layer();

    //* 初始化数据
    const sites = <number[]>[];

    //* 实例化文本对象
    const over = new Konva.Text({ text: `${origin.attachments.end}`, fill: "#6D747F", fontSize: 14, fontFamily: "sans-serif" });
    const begin = new Konva.Text({ text: `${origin.attachments.start}`, fill: "#6D747F", fontSize: 14, fontFamily: "sans-serif" });

    //* 绘图区域长度和比例初始化
    const width = setting.attachments - (over.getTextWidth() + begin.getTextWidth() + setting.spacing * 2 + 36);
    const ratio = width / (origin.attachments.end - origin.attachments.start + 1);

    //* 坐标轴绘制函数
    const axis = () => {
        //* 实例化结果
        const result = new Konva.Group();

        //* 坐标线绘制
        result.add(new Konva.Rect({ x: setting.spacing + begin.getTextWidth() + 16, y: 1, width: 2, height: 12, fill: "#6D747F" }));
        result.add(new Konva.Rect({ x: setting.spacing + begin.getTextWidth() + 18, y: 6, width: width, height: 2, fill: "#6D747F" }));
        result.add(
            new Konva.Rect({ x: setting.attachments - setting.spacing - over.getTextWidth() - 18, y: 1, width: 2, height: 12, fill: "#6D747F" })
        );

        //* 坐标文本绘制
        result.add(begin.x(setting.spacing).y(1));
        result.add(
            over
                .offsetX(over.getTextWidth())
                .x(setting.attachments - setting.spacing)
                .y(1)
        );

        return result;
    };

    //* Y轴排列函数
    const rows = (site: number, width: number, index: number): number => {
        if (!sites[index] || sites[index] + 8 <= site) {
            sites[index] = site + width;
        } else {
            return rows(site, width, index + 1);
        }

        return index;
    };

    const content = () => {
        //* 实例化结果
        const result = new Konva.Group();

        //* 绘制基因
        origin.attachments.data.forEach((value) => {
            //* 坐标初始化
            const end = (value.end - origin.attachments.data[0].start + 1) * ratio;
            const start = (value.start - origin.attachments.data[0].start) * ratio;
            const width = end - start;
            const color = value.target ? "#BE8EE4" : "#e3e3e3";

            //* 实例化分组对象
            const content = new Konva.Group({ x: setting.spacing + begin.getTextWidth() + 18, y: 36 });
            //* 实例化文本对象
            const context = new Konva.Text({
                y: 3,
                x: 0,
                text: value.name,
                fill: "#72299d",
                fontSize: 14,
                fontStyle: "bold",
                fontFamily: "sans-serif",
            });

            //* 实例化下划线
            const underline = new Konva.Rect({ x: 0, y: 17, width: context.getTextWidth(), height: 2, fill: "#72299d" });

            //* 绘制文本与下划线
            content.add(context);
            content.add(underline);

            //* 绘制箭头
            const offset = context.getTextWidth() + 8;
            if (value.strand) {
                content.add(new Konva.Rect({ x: offset, y: 5, width: width, height: 8, fill: color }));
                content.add(new Konva.Path({ data: `M${offset + width}, 0 l12, 10 l-12, 10 Z`, fill: color }));
            } else {
                content.add(new Konva.Rect({ x: offset + 12, y: 5, width: width, height: 8, fill: color }));
                content.add(new Konva.Path({ data: `M${offset}, 10 l12, -10 l0, 20 Z`, fill: color }));
            }

            //* 定位
            const site = start - offset;
            const row_site = rows(site, offset + width + 12, 0);
            //* 属性设置
            content.offset({ x: -site, y: (20 * row_site + 1 + 18 * row_site) * -1 });

            //* 事件注册
            context.on("click", () => open(routerResolve({ name: "Gene", params: { id: value.gene_id } }).href, "_blank"));
            context.on("mousemove", () => {
                context.fill("#9f50cb");
                underline.fill("#9f50cb");
                if (stage) {
                    stage.container().style.cursor = "pointer";
                }
            });

            context.on("mouseleave", () => {
                context.fill("#72299d");
                underline.fill("#72299d");
                if (stage) {
                    stage.container().style.cursor = "default";
                }
            });

            result.add(content);
        });

        return result;
    };

    //* 绘制
    canvas.add(axis());
    canvas.add(content());

    //* 结果
    stage.add(canvas);
    stage.height(sites.length * 20 + (sites.length - 1) * 18 + 36);
};
